const subMenuBtns  = document.querySelectorAll( '.mobileMenu .js-menuDropdown' );

/**
 * Check if the menu and menu items exists
 *
 * @return {boolean}
 */
const checkMenu = () => {

	if ( !subMenuBtns ) {

		return false;

	}
	return true;

}

/**
 * Deactivates all submenus
 */
const deactivateAllSubmenus = () => {

	subMenuBtns.forEach( submenu => {

		const itemContainer = submenu.closest( '.menu-item' );
		itemContainer.classList.remove( 'open' );

	} );

};

/**
 * Toggles the visibility of a submenu when a menu item is clicked.
 *
 * @param {Event} e - The event object.
 */
const toggleSubmenu = ( e ) => {

	const itemContainer = e.currentTarget.closest( '.menu-item' );
	if( !itemContainer ) {

		return;

	}
	if( itemContainer.classList.contains( 'open' ) ) {

		itemContainer.classList.remove( 'open' );

	} else {

		deactivateAllSubmenus();
		itemContainer.classList.add( 'open' );

	}

}


/**
 * Initializes event listeners for submenu buttons.
 */
const runEvents = () => {

	subMenuBtns.forEach( item => {

		item.addEventListener( 'click', toggleSubmenu );

	} );

}

/**
 * Checks if submenu buttons exist and initializes them if they do.
 * @return {void}
 */
const menu = () => {

	if ( !checkMenu() ) {

		return;

	}

	runEvents();

}

export { menu };
